import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { priceFormat } from '../../../../util';
import { oneBtnPopupCreator, twoBtnPopupCreator } from '../../../popups/ConfirmPopup/helper';
import * as Styled from '../SimplrOrder.styles';
import Loading from '../../../LoadingComponent/LoadingComponent';
import { Button } from '../../../common/buttonsComponents';
import { connect } from 'react-redux';
import { setSelectedTask } from '../../../../actions/tools/OrdersSearchActions';
import { refundSimplrOrder } from '../../../../actions/tools/SimplrOrderActions';
import { addNoteToTicket } from '../../../../actions';
import {
  getSelectedOrderFromOrdersSearch,
  extractSelectedInboxTab,
  extractSelectedTicketFromState,
  isSpecialist,
} from '../../../../extractFromState';
import { selectSelectedToolDomains } from '../../../../selectors/tools';
import NumberPillInput from '../../../controls/NumberPillInput/NumberPillInput';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import { showErrorPopup } from '../../../popups/ErrorPopup/ErrorPopup';
import BigNumber from 'bignumber.js';
import {
  RefundOrderButton,
  Divider,
  CancelStep,
  StepTitle,
  Subtext,
  ItemRow,
  Checkbox,
  RowContent,
  ItemDetail,
  RefundCommentTextarea,
  FlexPlaceholder,
  OrderSummaryBox,
  OrderSummaryHeader,
  OrderSummaryInfo,
  OrderSubtotalInfo,
} from './SimplrRefundOrder.styles';
import { handleError } from 'services/ErrorService/ErrorService';

const DESCRIPTION_WITH_REFUND = `The order may be eligible for a refund, the refund may take a few days to process, you can check order summary to see if it's actually refunded.`;
const DESCRIPTION_CLOSED = `All refundable items in this order were already cancelled.`;
const DEFAULT_CURRENCY = 'USD';

class SimplrRefundOrder extends Component {
  static propTypes = {
    selectedOrder: PropTypes.object.isRequired,
    selectedTicket: PropTypes.object,
    setSelectedTask: PropTypes.func,
    selectedToolDomains: PropTypes.object,
    isSpecialist: PropTypes.bool,
  };

  static defaultProps = {
    setSelectedTask: () => {},
  };

  async componentDidMount() {
    // TO DO: create an action for fetching OrderDetails
    const selectedOrder = this.props.selectedOrder;

    const actualRefundableItems = (selectedOrder.orderItems || [])
      .map((item) => {
        const refundedItem = this.simplrRefundDetails.find((refunded) => refunded.itemId === item.itemId);

        return {
          itemId: item.itemId,
          shipmentId: item.shipmentId,
          itemName: item.itemName,
          paidItemUnitPrice: item.paidItemUnitPrice,
          paidItemUnitTax: item.paidItemUnitTax,
          qty: refundedItem ? item.itemQuantity - refundedItem.quantity : item.itemQuantity,
        };
      })
      .filter((item) => item.qty > 0);

    const selectedItems = {};
    for (let refundableItem of actualRefundableItems) {
      selectedItems[refundableItem.itemId] = {
        qty: refundableItem.qty,
        active: true,
        shipmentId: refundableItem.shipmentId,
      };
    }
    const shippingCost = 0;
    const status = selectedOrder.orderStatus;

    this.setState({
      refundableItems: actualRefundableItems,
      selectedItems,
      status,
      shippingCost,
      isCancelOrderItemsRequesting: false,
    });
  }

  get orderItems() {
    return this.props.selectedOrder.orderItems;
  }

  state = {
    status: '',
    refundableItems: [],
    shippingCost: 0.0,
    currencyCode: 'USD',
    selectedItems: {},
    reasonComment: '',
    reasonError: false,
    isCancelRequesting: false,
    isCancelOrderItemsRequesting: true,
    isPolicyAccepted: false,
  };

  get orderId() {
    return this.props.selectedOrder.orderId;
  }

  get isSpecialist() {
    return this.props.isSpecialist;
  }

  // ------------
  // Step 1
  // ------------

  get isAllItemsSelected() {
    try {
      let result = true;

      for (let item of this.state.refundableItems) {
        const selectedItem = get(this.state.selectedItems, item.itemId, null);
        if (!selectedItem) {
          throw new Error('item not selected');
        }
        if (selectedItem.active === false) {
          result = false;
        }
      }

      return result;
    } catch (e) {
      showErrorPopup(`The selected item was not found`, 'Oops!');

      return false;
    }
  }

  handleSelectAll = () => {
    const selectedItems = cloneDeep(this.state.selectedItems);

    if (this.isAllItemsSelected) {
      for (let itemId of Object.keys(selectedItems)) {
        selectedItems[itemId].active = false;
      }
    } else {
      for (let item of this.state.refundableItems) {
        selectedItems[item.itemId].qty = item.qty;
        selectedItems[item.itemId].active = true;
      }
    }

    this.setState({ selectedItems });
  };

  handleSelectItem = (itemId) => {
    const selectedItems = cloneDeep(this.state.selectedItems);

    selectedItems[itemId].active = !selectedItems[itemId].active;

    this.setState({ selectedItems });
  };

  handleItemQtyChange = (itemId, newQty) => {
    const selectedItems = cloneDeep(this.state.selectedItems);

    selectedItems[itemId].qty = newQty;
    if (BigNumber(newQty).isEqualTo(BigNumber(0))) {
      selectedItems[itemId].active = !selectedItems[itemId].active;
    }
    this.setState({ selectedItems });
  };

  // ------------
  // Step 2
  // ------------

  handlerTextInputChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value });
  };

  // ------------
  // Totals
  // ------------

  get selectedQty() {
    try {
      let result = 0;

      for (let item of this.state.refundableItems) {
        const selectedItem = get(this.state.selectedItems, item.itemId, null);
        if (!selectedItem) {
          throw new Error('item not selected');
        }
        const qty = selectedItem.active ? selectedItem.qty : 0;

        result += qty;
      }

      return result;
    } catch (e) {
      showErrorPopup(`The selected item was not found`, 'Oops!');

      return 0;
    }
  }

  get subtotal() {
    try {
      let result = 0;

      for (let item of this.state.refundableItems) {
        const selectedItem = get(this.state.selectedItems, item.itemId, null);
        if (!selectedItem) {
          throw new Error('item not selected');
        }
        const itemSubtotal = selectedItem.active ? item.paidItemUnitPrice * selectedItem.qty : 0;
        result += itemSubtotal;
      }

      return result;
    } catch (e) {
      showErrorPopup(`The selected item was not found`, 'Oops!');

      return 0;
    }
  }

  get tax() {
    try {
      let result = 0;

      for (let item of this.state.refundableItems) {
        const selectedItem = get(this.state.selectedItems, item.itemId, null);
        if (!selectedItem) {
          throw new Error('item not selected');
        }
        const qty = selectedItem.active ? selectedItem.qty : 0;

        result += item.paidItemUnitTax * qty;
      }

      return result;
    } catch (e) {
      showErrorPopup(`The selected item was not found`, 'Oops!');

      return 0;
    }
  }

  get shipping() {
    const selectedOrder = this.props.selectedOrder;
    const shipmentQtys = {};
    for (const item of selectedOrder.orderItems || []) {
      const shipmentId = item.shipmentId;
      if (shipmentQtys[shipmentId]) {
        shipmentQtys[shipmentId] += item.itemQuantity;
      } else {
        shipmentQtys[shipmentId] = item.itemQuantity;
      }
    }

    for (const item of this.state.refundableItems) {
      const selectedItem = get(this.state.selectedItems, item.itemId, null);
      if (!selectedItem) {
        throw new Error('item not selected');
      }

      const qty = selectedItem.active ? selectedItem.qty : 0;
      shipmentQtys[selectedItem.shipmentId] -= qty;
    }

    const shipments = selectedOrder.shipment;
    let totalShippingRefund = 0;
    for (const shipmentId in shipmentQtys) {
      if (shipmentQtys[shipmentId] === 0) {
        const shipping = shipments.find((shipment) => shipment.shipmentId === shipmentId);
        totalShippingRefund += shipping.shipCostGross;
      }
    }

    return totalShippingRefund;
  }

  get totalRefund() {
    return this.subtotal + this.tax + this.shipping;
  }

  // ------------
  // Commons
  // ------------

  get hasRefundableItems() {
    return this.state.status !== 'CANCELLED' && !!this.state.refundableItems.length;
  }

  get placeholderText() {
    // TODO: Make this if string readable
    if (this.hasRefundableItems) {
      return DESCRIPTION_WITH_REFUND;
    }

    return DESCRIPTION_CLOSED;
  }

  /**
   * Formatting price with currency sign
   * @example 12 -> $12.00
   * @param {string|number} value
   * @return {string}
   */
  priceFormat = (value) => priceFormat(value, this.state.currencyCode);

  handleBackBtnClick = () => {
    this.props.setSelectedTask(null);
  };

  // ------------
  // Refund process
  // ------------

  displayPopupErrorMessage(message = '') {
    return oneBtnPopupCreator({
      content: {
        main: message,
        iconPath: '/images/error-esclamation.svg',
      },
      btnConfig: 'CLOSE',
    });
  }

  handleRefundBtnClick = () => {
    if (this.selectedQty === 0) {
      return this.displayPopupErrorMessage('Please add at least one item');
    }
    if (!this.state.reasonComment) {
      this.setState({ reasonError: true });

      return this.displayPopupErrorMessage('Please add reason for refund');
    }
    this.setState({ reasonError: false });
    twoBtnPopupCreator({
      content: {
        main: 'Are you sure you want to refund this order?',
        iconPath: '/images/green-alert-bell.svg',
      },
      btnConfig: {
        dismiss: 'DISMISS',
        confirm: 'REFUND ORDER',
      },
      onConfirm: this.confirmationHandler,
    });
  };

  get refundDetails() {
    const selectedIds = Object.keys(this.state.selectedItems).filter((id) => {
      const item = this.state.selectedItems[id];

      return item.active && item.qty !== 0;
    });

    return selectedIds.map((id) => ({
      itemId: id,
      quantity: this.state.selectedItems[id].qty,
    }));
  }

  confirmationHandler = async () => {
    let messageBody = '';
    messageBody += `Refund order, Order #${this.orderId}.\n`;
    messageBody += `Reason for refund: ${this.state.reasonComment}\n`;
    messageBody += `Amount refunded: $${parseFloat(this.totalRefund).toFixed(2)}`;

    this.setState({ isCancelRequesting: true });

    const payload = {
      orderId: this.orderId,
      refundTotalAmount: this.totalRefund,
      refundDetails: this.refundDetails,
      domain: this.props.domain,
    };

    const { simplrAccountPtrId } = this.props.selectedTicket;

    try {
      const response = await this.props.refundSimplrOrder(simplrAccountPtrId, payload);
      if (!response.success) {
        this.handleFailedRefund(response.errorMessage);
      } else {
        if (this.props.selectedInboxTab === 'assigned') {
          await this.props.addNoteToTicket(messageBody, this.props.selectedTicket);
        }
        this.handleSuccessRefund();
      }
    } catch (e) {
      // We have to do this because axios is returning a string that we can't parse directly. It's automatically combining the data object as a string with the error message
      // and we still don't know why - 5/6/2019
      let errorMessage;
      const errorArray = e.message.split('Not Found');
      errorArray.length > 1 ? (errorMessage = JSON.parse(errorArray[1]).errorMessage) : (errorMessage = undefined);
      this.handleFailedRefund(errorMessage);
      handleError({ error: e, customMessage: errorMessage });
    }
  };

  handleSuccessRefund = () => {
    this.setState({ isCancelRequesting: false });

    this.props.setSelectedTask(null);

    oneBtnPopupCreator({
      content: {
        main: `Refund order request sent: Refund ${parseFloat(this.totalRefund).toFixed(2)}${this.state.currencyCode}`,
        iconPath: '/images/checkmark-green.svg',
      },
      btnConfig: 'CLOSE',
    });
  };

  handleFailedRefund = (message = undefined) => {
    this.setState({ isCancelRequesting: false });
    if (message === undefined) {
      oneBtnPopupCreator({
        content: {
          main: 'Cancel order failed',
          iconPath: '/images/error-esclamation.svg',
        },
        btnConfig: 'CLOSE',
      });
    } else {
      oneBtnPopupCreator({
        content: {
          main: `${message}`,
          iconPath: '/images/error-esclamation.svg',
        },
        btnConfig: 'CLOSE',
      });
    }
  };

  get isSimplrRefundDetailsExist() {
    const selectedOrder = this.props.selectedOrder;

    return !!(selectedOrder.simplrRefundDetails && selectedOrder.simplrRefundDetails.length);
  }

  get simplrRefundDetails() {
    const selectedOrder = this.props.selectedOrder;

    return selectedOrder && selectedOrder.simplrRefundDetails ? selectedOrder.simplrRefundDetails : [];
  }

  // ------------
  // Item attributes
  // ------------
  getItemAttr(item) {
    const { extension } = item;
    const result = extension.reduce((res, elem) => {
      res.push(`${elem.label}: ${elem.value}`);

      return res;
    }, []);

    if (result.length) {
      return `(${result.join(', ')})`;
    }

    return null;
  }

  // ------------
  // Renders
  // ------------

  renderComponent() {
    const refundableItemsJSX = this.state.refundableItems.map((item) => {
      const { itemId } = item;
      const selectedItem = this.state.selectedItems[itemId];

      return (
        <ItemRow key={itemId}>
          <Checkbox type="checkbox" checked={selectedItem.active} onChange={() => this.handleSelectItem(itemId)} />
          <RowContent>
            <ItemDetail active={selectedItem.active}>
              ({item.qty}) {item.itemName}
            </ItemDetail>
            {selectedItem && (
              <NumberPillInput
                qty={selectedItem.qty}
                min={0}
                step={1}
                max={item.qty}
                onChange={(newQty) => this.handleItemQtyChange(itemId, newQty)}
              />
            )}
          </RowContent>
        </ItemRow>
      );
    });

    const selectedOrder = this.props.selectedOrder;
    const currencyCode = selectedOrder.currency || DEFAULT_CURRENCY;
    const orderRefundRequestedAmount = parseFloat(selectedOrder.totalRefundRequestedToOrder || 0);

    const refundedItemsJSX = this.simplrRefundDetails.map((item) => {
      const { itemId, quantity } = item;
      const orderItem = (selectedOrder.orderItems || []).find((orderItems) => itemId === orderItems.itemId);

      if (!orderItem) {
        return null;
      }

      return (
        <div key={itemId}>
          <ItemRow>
            <RowContent key="content">
              <ItemDetail key="itemDetail" active={false}>
                ({quantity}) {orderItem.itemName}
              </ItemDetail>
            </RowContent>
          </ItemRow>
        </div>
      );
    });

    return (
      <Styled.OrderTaskWrapper>
        <Styled.OrderTaskTitle>Refund Order</Styled.OrderTaskTitle>
        <Styled.OrderTaskDescription>{this.placeholderText}</Styled.OrderTaskDescription>

        {this.isSimplrRefundDetailsExist && (
          <CancelStep>
            <StepTitle>Following items have been already refunded.</StepTitle>
            {refundedItemsJSX}
          </CancelStep>
        )}

        {this.hasRefundableItems && (
          <CancelStep>
            {this.hasRefundableItems ? (
              <StepTitle>
                <Subtext>Step 1 - </Subtext>Following items can be refunded. Please select product (s) and change
                quantity if different. Note: Total refund already requested:{' '}
                {priceFormat(orderRefundRequestedAmount, currencyCode)}
              </StepTitle>
            ) : (
              <StepTitle>None of the items in this order are refundable.</StepTitle>
            )}

            {this.hasRefundableItems && (
              <ItemRow>
                <Checkbox type="checkbox" checked={this.isAllItemsSelected} onChange={() => this.handleSelectAll()} />
                <RowContent>
                  <Subtext>Select all</Subtext>
                </RowContent>
              </ItemRow>
            )}

            <Divider />

            {this.hasRefundableItems && refundableItemsJSX}

            <Divider />
          </CancelStep>
        )}

        {this.hasRefundableItems && (
          <CancelStep>
            <StepTitle>
              <Subtext>Step 2 - </Subtext>Select reason for refund (mandatory)
            </StepTitle>

            <RowContent>
              <RefundCommentTextarea
                name="reasonComment"
                value={this.state.reasonComment}
                onChange={this.handlerTextInputChange}
              />

              <FlexPlaceholder />

              <OrderSummaryBox>
                <OrderSummaryHeader>Refund Summary:</OrderSummaryHeader>
                <OrderSummaryInfo>
                  <RowContent>
                    <div>Subtotal</div>
                    <div>{this.priceFormat(parseFloat(this.subtotal).toFixed(2))}</div>
                  </RowContent>
                  <RowContent>
                    <div>Tax</div>
                    <div>{this.priceFormat(parseFloat(this.tax).toFixed(2))}</div>
                  </RowContent>
                  <RowContent>
                    <div>Shipping</div>
                    <div>{this.priceFormat(parseFloat(this.shipping).toFixed(2))}</div>
                  </RowContent>
                  <Divider />
                  <RowContent>
                    <OrderSubtotalInfo>Refund total</OrderSubtotalInfo>
                    <OrderSubtotalInfo>{this.priceFormat(parseFloat(this.totalRefund).toFixed(2))}</OrderSubtotalInfo>
                  </RowContent>
                </OrderSummaryInfo>
              </OrderSummaryBox>
            </RowContent>
          </CancelStep>
        )}

        <Styled.OrderTaskControls>
          <Button onClick={this.handleBackBtnClick}>BACK</Button>
          {this.hasRefundableItems && (
            <RefundOrderButton active={true} onClick={this.handleRefundBtnClick}>
              REFUND ORDER
            </RefundOrderButton>
          )}
        </Styled.OrderTaskControls>
      </Styled.OrderTaskWrapper>
    );
  }

  render() {
    if (this.state.isCancelRequesting) {
      return <Loading label="Refund order..." />;
    }
    if (this.state.isCancelOrderItemsRequesting) {
      return <Loading label="Loading cancel information..." />;
    }

    return this.renderComponent();
  }
}

function mapStateToProps(state) {
  const selectedOrder = getSelectedOrderFromOrdersSearch(state);

  return {
    selectedOrder: selectedOrder,
    selectedTicket: extractSelectedTicketFromState(state),
    selectedInboxTab: extractSelectedInboxTab(state),
    selectedToolDomains: selectSelectedToolDomains(state),
    isSpecialist: isSpecialist(state),
    domain: selectedOrder.domain || null,
  };
}

export default connect(mapStateToProps, {
  setSelectedTask,
  addNoteToTicket,
  refundSimplrOrder,
})(SimplrRefundOrder);
